'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dUniqueness$002dCache from "./scala.-Uniqueness-Cache.js";
var $p;
/** @constructor */
function $c_s_Symbol$() {
  this.An = null;
  $j_scala$002e$002dUniqueness$002dCache.$ct_s_UniquenessCache__(this);
}
export { $c_s_Symbol$ as $c_s_Symbol$ };
$p = $c_s_Symbol$.prototype = new $j_scala$002e$002dUniqueness$002dCache.$h_s_UniquenessCache();
$p.constructor = $c_s_Symbol$;
/** @constructor */
function $h_s_Symbol$() {
}
export { $h_s_Symbol$ as $h_s_Symbol$ };
$h_s_Symbol$.prototype = $p;
var $d_s_Symbol$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_s_Symbol$, "scala.Symbol$", ({
  s4: 1,
  s7: 1
}));
export { $d_s_Symbol$ as $d_s_Symbol$ };
var $n_s_Symbol$;
function $m_s_Symbol$() {
  if ((!$n_s_Symbol$)) {
    $n_s_Symbol$ = new $c_s_Symbol$();
  }
  return $n_s_Symbol$;
}
export { $m_s_Symbol$ as $m_s_Symbol$ };
